<template>
	<leaflet-layer-group ref="layerGroup">
		<leaflet-marker
			v-if="trip && currentPosition"
			ref="currentPosition"
			:latitude="startPosition.latitude"
			:longitude="startPosition.longitude"
			:icon="tripStartIcon"
			:iconColor="tripStartIconColor"
			bringToFront
			isSelected
			@click="onLiveMarkerClicked"
			@rendered="enableCurrentPositionDroppable"
		/>
		<leaflet-marker
			v-if="!isRoundTrip && endPosition"
			ref="endPosition"
			:latitude="endPosition.latitude"
			:longitude="endPosition.longitude"
			:icon="tripEndIcon"
			iconColor="blue"
			isSelected
			@rendered="enableEndPositionDroppable"
		/>

		<t-poly-line
			:points="actualPoints"
			lineStyle="solid"
			:color="tripStartIconColor"
			:width="3"
			addArrows
		/>
		<t-poly-line :points="estimatedPoints" :width="3" addArrows/>
	</leaflet-layer-group>
</template>

<script>
import createIconMixin from '@/components/map/CreateIcon.mixin.js';
import { statuses } from '@/core';
import { addAsDroppable, removeAsDroppable } from '@/DragDrop.js';

export default {
	name: 'MapTrip',
	mixins: [createIconMixin],
	props: { trip: { type: Object, } },
	data() {
		return { position: null, };
	},
	computed: {
		currentPosition() {
			return this.trip.currentPosition ? this.getLatLng(this.trip.currentPosition.coords) : undefined;
		},
		startPosition() {
			return this.getLatLng(this.trip.fromAddress);
		},
		endPosition() {
			return this.getLatLng(this.trip.toAddress);
		},
		isRoundTrip() {
			let fromLatLng = this.getLatLng(this.trip.fromAddress);
			let toLatLng = this.getLatLng(this.trip.toAddress);
			return this.compareLatLng(fromLatLng, toLatLng);
		},
		actualPoints() {
			if (!this.trip.atd) return [];
			let points = [this.trip.fromAddress,];
			if (this.getLatLng(this.currentPosition))
				points.push(this.getLatLng(this.currentPosition));
			if (this.trip.ata && this.getLatLng(this.trip.fromAddress))
				points.push(this.trip.fromAddress);
			return points;
		},
		estimatedPoints() {
			let points = [];
			if (!this.trip.atd && this.getLatLng(this.trip.fromAddress))
				points.push(this.getLatLng(this.trip.fromAddress));
			if (this.trip.atd && this.currentPosition)
				points.push(this.currentPosition);

			points.push(this.trip.toAddress);
			return points;
		},
		tripStartIcon() {
			return this.createIcon({
				iconName: 'trip',
				iconType: 'tim',
			});
		},
		tripStartIconColor() {
			return statuses.color(this.trip.status);
		},
		tripEndIcon() {
			return this.createIcon({
				iconName: 'trip-end',
				iconType: 'tim',
			});
		}
	},
	watch: {
		trip: {
			immediate: true,
			handler(newVal, oldVal) {
				if (oldVal) {
					removeAsDroppable(`mapTrip-currentPosition-${oldVal.id}`);
					removeAsDroppable(`mapTrip-endPosition-${oldVal.id}`);
				}
			}
		},
	},
	methods: {
		handleDrop(orders) {
			if (!Array.isArray(orders)) {
				orders = [orders];
			}
			this.$emit('showAddToTrip', { trip: this.trip, orders: orders });
		},
		async enableCurrentPositionDroppable() {
			await this.$nextTick();
			if (!this.$refs.currentPosition) return;
			addAsDroppable(this.$refs.currentPosition.getHtml(), `mapTrip-currentPosition-${this.trip.id}`, (payload) => this.handleDrop(payload) );
		},
		async enableEndPositionDroppable() {
			await this.$nextTick();
			if (!this.$refs.endPosition) return;
			addAsDroppable(this.$refs.endPosition.getHtml(), `mapTrip-endPosition-${this.trip.id}`, (payload) => this.handleDrop(payload) );
		},
		onLiveMarkerClicked(marker) {
			console.log(marker);
		},
		getLatLng(obj) {
			if (obj && obj.latitude && obj.longitude) {
				return { latitude: obj.latitude, longitude: obj.longitude };
			}
			return null;
		},
		compareLatLng(latLng1, latLng2) {
			if (!latLng1 || !latLng2) return false;
			return latLng1.latitude === latLng2.latitude && latLng1.longitude === latLng2.longitude;
		},
		getIconColor(date) {
			return date ? 'white' : '#dbeaf7';
		},
		getIconBackground(date) {
			return date ? '#ee9913' : '#1070ca';
		}
	}
};
</script>

<style lang="scss" scoped>

</style>